module.exports = __webpack_public_path__ + "static/media/icon_trash.f2275e11.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_trash.svg
// module id = 2092
// module chunks = 0